import Entity from "./entity";
import ClientService from "./../entities/clients/client-service";
import Address from "./../entities/address";

export default class Client extends Entity<string> {
  code: string;
  name: string;
  shortName: string;
  addressId: number;
  contactName: string;
  contactPhone: string;
  fax: string;
  tax: string;
  type: string;
  email: string;
  status: string;
  logoUrl: string;
  receiveMode: string;
  fullAddress: string;
  extraServices: ClientService[];
  assetTypeServices: ClientService[];
  shippingServices: ClientService[];
  typeName: string;
  address: Address;
  createNotificationConfigs: any[];
}
